import { useEffect } from "react";
import smartlookClient from "smartlook-client";
import { useBoolean } from "../helpers/useBoolean";

const PROJECT_KEY = "a9de61387e3ee0faec6a979ba60e3c85f9ad21a6";

export function useSmartlook(meData) {
  useInit();
  useIdentify(meData);
}

function useInit() {
  useEffect(() => {
    try {
      smartlookClient.init(PROJECT_KEY);
    } catch (e) {
      console.log("Failed smartlook init");
    }
  }, []);
}

function useIdentify(meData) {
  const identified = useBoolean(false);
  const myEmail = meData?.email ?? null;

  useEffect(() => {
    if (myEmail && !identified.value) {
      try {
        smartlookClient.identify(myEmail, meData);
        identified.setTrue();
      } catch (e) {
        console.log("Failed smartlook identify");
      }
    }
  }, [myEmail]);
}
